import QuoteEventsTimeLine from "../../../quote/analytics/eventstimeline.component"
import React from "react"
import { useSelector } from "react-redux"
import { InventoryStockDocumentSelector } from "../../../state/inventory"
import { ProposalSelector } from "../../../state/proposal/selectors"
import { useProposalEmails } from "../../../common/hooks"
import { ProjectSelector } from "../../../state/project"

export const StockDocumentTimeline = () => {
    const doc = useSelector(InventoryStockDocumentSelector.getStructured)
    const project = useSelector(ProjectSelector.getStructured)
    const prop = useSelector(ProposalSelector.getStructured)
    const {emails} = useProposalEmails(prop.id, prop.attributes.emailSent)

    return (
        <QuoteEventsTimeLine
            emails={emails}
            stockDocument={doc}
            proposal={prop}
            project={project ?? doc.attributes.project}
            isEditable={false}
        />
    )

}


// WEBPACK FOOTER //
// ./src/inventory/sections/control/StockDocumentTimeline.tsx